

export class StatusMainMenuInput implements IStatusMainMenuInput {
    /** The auto-generated id of the tbl_application_menu */
    applicationMenuId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IStatusMainMenuInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationMenuId = _data["applicationMenuId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StatusMainMenuInput {
        data = typeof data === 'object' ? data : {};
        let result = new StatusMainMenuInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationMenuId"] = this.applicationMenuId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IStatusMainMenuInput {
    /** The auto-generated id of the tbl_application_menu */
    applicationMenuId: number;
    /** The updated status */
    status: number;
}

